import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faUnlockAlt,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
} from '@themesberg/react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Routes } from '../../config/routes';
import { CustomToast, Loader } from '../../components/common';
import { useRegisterMutation } from '../../features/auth/auth.api';

export default () => {
  let history = useHistory();
  const [registerUser, { isLoading }] = useRegisterMutation();

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');

  const clearFields = () => {
    setName('');
    setEmail('');
    setPassword('');
  };

  async function handleSignUp(e) {
    e.stopPropagation();
    e.preventDefault();

    if (name === '' || email === '' || password === '') {
      toast.error('Please fill in all the fields');
    } else {
      await registerUser({ name, email, password })
        .unwrap()
        .then((payload) => {
          localStorage.setItem('accessToken', payload.tokens.access.token);
          localStorage.setItem('refreshToken', payload.tokens.refresh.token);
          localStorage.setItem('userId', payload.user.id);
          clearFields();
          history.push(Routes.Signin.path);
          toast.success('Please wait for admin to approve your account');
        });
    }
  }

  return (
    <main className='bg-tertiary'>
      <CustomToast />
      <Loader loaded={!isLoading}>
        <section className='d-flex align-items-center my-5 mt-lg-3 mb-lg-5'>
          <Container>
            <Row className='justify-content-center'>
              <Col
                xs={12}
                className='d-flex align-items-center justify-content-center'
              >
                <div className='mb-4 mb-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500'>
                  <div className='text-center text-md-center mb-4 mt-md-0'>
                    <h3 className='mb-0'>Create an account</h3>
                  </div>
                  <Form className='mt-4'>
                    <Form.Group
                      id='name'
                      className='mb-4'
                    >
                      <Form.Label>Your Name</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUser} />
                        </InputGroup.Text>
                        <Form.Control
                          autoFocus
                          required
                          type='text'
                          placeholder='John Doe'
                          onChange={(e) => setName(e.target.value)}
                        />
                      </InputGroup>
                    </Form.Group>
                    <Form.Group
                      id='email'
                      className='mb-4'
                    >
                      <Form.Label>Your Email</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faEnvelope} />
                        </InputGroup.Text>
                        <Form.Control
                          autoFocus
                          required
                          type='email'
                          placeholder='example@company.com'
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </InputGroup>
                    </Form.Group>
                    <Form.Group
                      id='password'
                      className='mb-4'
                    >
                      <Form.Label>Your Password</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type='password'
                          placeholder='Password'
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </InputGroup>
                    </Form.Group>

                    <Button
                      variant='primary'
                      type='submit'
                      className='w-100'
                      onClick={handleSignUp}
                    >
                      Sign up
                    </Button>
                  </Form>

                  <div className='d-flex justify-content-center align-items-center mt-4'>
                    <span className='fw-normal'>
                      Already have an account?
                      <Card.Link
                        as={Link}
                        to={Routes.Signin.path}
                        className='fw-bold'
                      >
                        {` Login here `}
                      </Card.Link>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Loader>
    </main>
  );
};
